// Detailed product data with pricing and variants
export const detailedProducts = {

  // ─── DINING SETS ──────────────────────────────────────────────────────────

  'dining-3pieces': {
    id: 'dining-3pieces',
    name: '3 Pieces Dining Set',
    category: 'Dining Sets',
    description: 'A compact 3-piece dining set crafted for everyday luxury. Designed for personal dining or thoughtful gifting.',
    longDescription: 'Handcrafted in Jezzine using traditional artisanal techniques, this 3-piece collection brings refined elegance to your table setting. Featuring a fork, spoon, and knife, each piece is individually weighted and balanced for everyday dining while preserving the signature quality of Chahine Cutlery.',
    variants: [
      {
        id: 'dining-3-black',
        name: 'Black Finish',
        images: [
          '/images/items/DiningSetB3.jpg'
        ]
      },
      {
        id: 'dining-3-white',
        name: 'White Finish',
        images: [
          '/images/items/DiningSetW1.jpg'
        ]
      }
    ],
    pricing: [
      {
        pieces: 3,
        price: 50,
        description: '3-piece set without box'
      }
    ]
  },

  'dining-18pieces': {
    id: 'dining-18pieces',
    name: '18 Pieces Dining Set',
    category: 'Dining Sets',
    description: 'An 18-piece dining set presented in a signature display case, tailored for intimate family dinners and small gatherings.',
    longDescription: 'Handcrafted in Jezzine to showcase generations of technique, this 18-piece collection offers a balanced suite of table utensils designed for daily elegance. Each piece is shaped for ergonomic comfort and durability, housed in a custom presentation box that makes it as easy to store as it is to gift.',
    variants: [
      {
        id: 'dining-18-black',
        name: 'Black Finish',
        images: [
          '/images/items/18 pieces-black.webp'
        ]
      },
      {
        id: 'dining-18-white',
        name: 'White Finish',
        images: [
          '/images/items/18 pieces-white.webp',
          '/images/items/18 pieces2-white.webp'
        ]
      }
    ],
    pricing: [
      {
        pieces: 18,
        price: 325,
        description: '18-piece dining set — perfect for small families'
      }
    ]
  },

  'dining-22pieces': {
    id: 'dining-22pieces',
    name: '22 Pieces Dining Set',
    category: 'Dining Sets',
    description: 'An expanded 22-piece dining set housed in a wooden display box, featuring extra serving utensils for versatile entertaining.',
    longDescription: 'Handcrafted in Jezzine, this 22-piece collection builds on our essential table service by adding dedicated serving pieces for seamless hosted meals. Each item is individually finished by hand for long-lasting performance and stored in a fitted presentation case.',
    variants: [
      {
        id: 'dining-22-white',
        name: 'White Finish',
        images: [
          '/images/items/22 pieces1-white.webp'
        ]
      }
    ],
    pricing: [
      {
        pieces: 22,
        price: 425,
        description: '22-piece dining set — expanded family collection'
      }
    ]
  },

  'dining-40pieces': {
    id: 'dining-40pieces',
    name: '40 Pieces Dining Set',
    category: 'Dining Sets',
    description: 'A 40-piece dining set presented in a multi-tier wooden chest, designed for larger family gatherings and frequent hosting.',
    longDescription: 'Handcrafted in Jezzine to high standards of artisanal perfection, this 40-piece collection provides a full suite of dining and serving utensils. Arranged across structured wooden drawers, each piece offers ergonomic comfort and timeless durability for formal dinners and special occasions.',
    variants: [
      {
        id: 'dining-40-black',
        name: 'Black Finish',
        images: [
          '/images/items/40 pieces-black.webp'
        ]
      },
      {
        id: 'dining-40-white',
        name: 'White Finish',
        images: [
          '/images/items/40 pieces1-white.webp',
          '/images/items/40 pieces-white.webp'
        ]
      }
    ],
    pricing: [
      {
        pieces: 40,
        price: 800,
        description: '40-piece dining set — ideal for larger families'
      }
    ]
  },

  'dining-80pieces': {
    id: 'dining-80pieces',
    name: '80 Pieces Dining Set',
    category: 'Dining Sets',
    description: 'The ultimate 80-piece master dining collection, housed in an elaborate multi-drawer wooden case for grand occasions and luxury entertaining.',
    longDescription: 'Representing the apex of Chahine Cutlery, this flagship 80-piece suite covers every dining and serving need imaginable. Handcrafted in Jezzine with meticulous attention to balance and detail, each utensil is neatly displayed in a grand, tiered wooden chest—making it a true heirloom investment for generations to come.',
    variants: [
      {
        id: 'dining-80-white',
        name: 'White Finish',
        images: [
          '/images/items/80 pieces1-white.webp',
          '/images/items/80 pieces2-white.webp'
        ]
      }
    ],
    pricing: [
      {
        pieces: 80,
        price: 1500,
        description: '80-piece dining set — complete grand collection'
      }
    ]
  },

  // ─── SERVING SETS ─────────────────────────────────────────────────────────

  'salad-set': {
    id: 'salad-set',
    name: 'Salad Serving Set',
    category: 'Serving Sets',
    description: 'An elegant 2-piece salad serving set presented in a custom wooden box, crafted for graceful table presentation.',
    longDescription: 'Handcrafted in Jezzine, this set includes a wide serving spoon and matching fork designed to lift and toss greens effortlessly. Each utensil combines comfortable handling with balanced weight distribution, offering a refined touch to both everyday meals and dinner parties.',
    variants: [
      {
        id: 'salad-black',
        name: 'Black Finish',
        images: [
          '/images/items/Salad set-black.webp'
        ]
      },
      {
        id: 'salad-white',
        name: 'White Finish',
        images: [
          '/images/items/Salad set1- white.webp'
        ]
      }
    ],
    pricing: [
      {
        pieces: 2,
        price: 55,
        description: '2-piece salad serving set — spoon and fork'
      }
    ]
  },

  'cake-set': {
    id: 'cake-set',
    name: 'Cake Serving Set',
    category: 'Serving Sets',
    description: 'A 2-piece cake serving set housed in a presentation box, designed for celebrations and dessert service.',
    longDescription: 'Handcrafted in Jezzine, this 2-piece set features a cake server and matching knife engineered for smooth slicing and effortless serving. Each piece offers comfortable ergonomic balance and hand-finished detailing, bringing a touch of refinement to special occasions.',
    variants: [
      {
        id: 'cake-white',
        name: 'White Finish',
        images: [
          '/images/items/Cake set1-white.webp'
        ]
      }
    ],
    pricing: [
      {
        pieces: 2,
        price: 55,
        description: '2-piece cake set — server and knife'
      }
    ]
  },

  'serving-4pieces': {
    id: 'serving-4pieces',
    name: '4 Pieces Serving Set',
    category: 'Serving Sets',
    description: 'A versatile 4-piece serving set presented in a signature wooden box, crafted to handle host essentials for both daily meals and casual gatherings.',
    longDescription: 'Handcrafted in Jezzine, this 4-piece hostess set includes essential serving utensils engineered for practical utility and balanced handling. Each piece is individually finished by hand and neatly arranged in a custom presentation case, ensuring seamless serving and lasting durability.',
    variants: [
      {
        id: 'serving-4-black',
        name: 'Black Finish',
        images: [
          '/images/items/4 pieces-black.webp'
        ]
      },
      {
        id: 'serving-4-white',
        name: 'White Finish',
        images: [
          '/images/items/4 pieces1-white.webp'
        ]
      }
    ],
    pricing: [
      {
        pieces: 4,
        price: 95,
        description: '4-piece serving set'
      }
    ]
  },

  'serving-7pieces': {
    id: 'serving-7pieces',
    name: '7 Pieces Serving Set',
    category: 'Serving Sets',
    description: 'A 7-piece serving set designed for hosting and entertaining with style.',
    longDescription: 'Handcrafted in Jezzine, this 7-piece set provides a full range of serving tools to complement any table setting. Each piece is individually hand-finished to ensure effortless handling, superior balance, and the lasting quality that defines Chahine Cutlery.',
    variants: [
      {
        id: 'serving-7-white',
        name: 'White Finish',
        images: [
          '/images/items/7 pieces-white.webp',
          '/images/items/7 pieces1-white.webp'
        ]
      }
    ],
    pricing: [
      {
        pieces: 7,
        price: 150,
        description: '7-piece serving set'
      }
    ]
  },

  // ─── ORNAMENTALS ──────────────────────────────────────────────────────────

  'ceremonial-dagger': {
    id: 'ceremonial-dagger',
    name: 'Ceremonial Dagger Collection',
    category: 'Ornamentals',
    description: 'An exquisite ceremonial dagger presented in a velvet-lined wooden case, showcasing decorative craftsmanship and blade-making tradition.',
    longDescription: 'Handcrafted in Jezzine, each ceremonial dagger stands as a centerpiece of fine metalwork and detailed engraving. Combining premium materials with historical art forms, this collector piece is designed for ceremonial honor, prestigious gifting, or distinguished display.',
    variants: [
      {
        id: 'dagger-classic',
        name: 'Classic',
        images: [
          '/images/items/Dagger1.webp',
          '/images/items/Dagger2.webp',
          '/images/items/Dagger3.webp',
          '/images/items/Dagger 4.webp'
        ]
      }
    ],
    pricing: [
      {
        pieces: 1,
        price: 350,
        description: 'Single ceremonial dagger'
      }
    ]
  },

  // ─── OLIVE WOOD ───────────────────────────────────────────────────────────

  'olivewood-18pieces': {
    id: 'olivewood-18pieces',
    name: '18 Pieces Olive Wood Set',
    category: 'Olive Wood',
    description: 'Handcrafted 18-piece dining set with beautiful olive wood handles, sourced from the Mediterranean.',
    longDescription: 'Our olive wood 18-piece set blends the warmth of natural Mediterranean olive wood with precision metalwork. Each handle is unique, showcasing the natural grain patterns of sustainably sourced olive wood, making every set one of a kind.',
    variants: [
      {
        id: 'olivewood-18-natural',
        name: 'Olive Wood',
        images: [
          '/images/items/18 pieces1-olivewood.webp',
          '/images/items/18 pieces2-olivewood.webp'
        ]
      }
    ],
    pricing: [
      {
        pieces: 18,
        price: 375,
        description: '18-piece olive wood dining set'
      }
    ]
  },

  'olivewood-salad': {
    id: 'olivewood-salad',
    name: 'Olive Wood Salad Set',
    category: 'Olive Wood',
    description: 'Artisan salad serving set with natural olive wood handles — a beautiful combination of warmth and elegance.',
    longDescription: 'Crafted from sustainably sourced Mediterranean olive wood, each salad serving set features unique grain patterns that make it truly one of a kind. The natural oils in the wood provide antimicrobial properties while adding rustic warmth to any table.',
    variants: [
      {
        id: 'olivewood-salad-natural',
        name: 'Olive Wood',
        images: [
          '/images/items/Salad set-olivewood.webp'
        ]
      }
    ],
    pricing: [
      {
        pieces: 2,
        price: 65,
        description: '2-piece olive wood salad serving set'
      }
    ]
  },

  // ─── OTHERS ───────────────────────────────────────────────────────────────

  'office-set': {
    id: 'office-set',
    name: 'Office Set',
    category: 'Others',
    description: 'A refined office set crafted with Chahine precision — the perfect desk accessory. Available in Black and White finishes.',
    longDescription: 'Our office set brings the elegance of Chahine craftsmanship to your workspace. Each piece is carefully balanced and finished for both functionality and visual appeal, making it an ideal gift for professionals.',
    variants: [
      {
        id: 'office-black',
        name: 'Black Finish',
        images: [
          '/images/items/Office set-black.webp',
          '/images/items/Office set1-black.webp'
        ]
      },
      {
        id: 'office-white',
        name: 'White Finish',
        images: [
          '/images/items/office set-white.webp'
        ]
      }
    ],
    pricing: [
      {
        pieces: 1,
        price: 65,
        description: 'Complete office set'
      }
    ]
  },

  'rosto-set': {
    id: 'rosto-set',
    name: 'Rosto Set',
    category: 'Serving Sets',
    description: 'A unique specialty serving set crafted in our signature white finish.',
    longDescription: 'The Rosto set is a distinctive piece in the Chahine collection, combining traditional craftsmanship with a refined aesthetic. Hand-finished to our exacting standards.',
    variants: [
      {
        id: 'rosto-white',
        name: 'White Finish',
        images: [
          '/images/items/Rosto1-white.webp'
        ]
      }
    ],
    pricing: [
      {
        pieces: 1,
        price: 75,
        description: 'Rosto specialty serving set'
      }
    ]
  },

  // ─── OLIVE WOOD — CAKE SET ────────────────────────────────────────────────
  // Note: Using salad set image as placeholder until olive wood cake set images are available

  'olivewood-cake': {
    id: 'olivewood-cake',
    name: 'Olive Wood Cake Set',
    category: 'Olive Wood',
    description: 'Artisan cake serving set with natural olive wood handles — warmth and elegance for your dessert table.',
    longDescription: 'Crafted from sustainably sourced Mediterranean olive wood, this cake set pairs the beauty of natural wood grain with precise metalwork. Each handle is unique, making every set a one-of-a-kind piece.',
    variants: [
      {
        id: 'olivewood-cake-natural',
        name: 'Olive Wood',
        images: [
          '/images/items/Salad set- olive wood.webp'
        ]
      }
    ],
    pricing: [
      {
        pieces: 2,
        price: 65,
        description: '2-piece olive wood cake serving set'
      }
    ]
  },

  // ─── OLIVE WOOD — OFFICE SET ──────────────────────────────────────────────

  'office-set-olivewood': {
    id: 'office-set-olivewood',
    name: 'Olive Wood Office Set',
    category: 'Olive Wood',
    description: 'A refined office set with natural olive wood accents — the perfect desk accessory crafted with Chahine precision.',
    longDescription: 'Our olive wood office set brings the warmth of sustainably sourced Mediterranean olive wood to your workspace. Each piece showcases unique natural grain patterns while delivering the balanced, hand-finished quality Chahine is known for, making it an ideal gift for professionals.',
    variants: [
      {
        id: 'office-olivewood-natural',
        name: 'Olive Wood',
        images: [
          '/images/items/Office set olive wood.webp',
          '/images/items/Office set olive wood zoomedIn.webp'
        ]
      }
    ],
    pricing: [
      {
        pieces: 1,
        price: 85,
        description: 'Complete olive wood office set'
      }
    ]
  },

  // ─── OTHERS ───────────────────────────────────────────────────────────────

  'bar-set': {
    id: 'bar-set',
    name: 'Bar Set',
    category: 'Others',
    description: 'An elegant bar set crafted with Chahine precision — the perfect companion for entertaining. Available in Black and White finishes.',
    longDescription: 'Our bar set combines refined craftsmanship with everyday functionality. Each piece is carefully balanced and hand-finished, making it a distinguished addition to any home bar or a thoughtful gift for those who love to host.',
    variants: [
      {
        id: 'bar-black',
        name: 'Black Finish',
        images: [
          '/images/items/Bar set black.webp',
          '/images/items/bar set black zoomed in.webp',
          '/images/items/bar set black zoomed in 1.webp'
        ]
      },
      {
        id: 'bar-white',
        name: 'White Finish',
        images: [
          '/images/items/bar set white.webp',
          '/images/items/bar set white zoomed in.webp',
          '/images/items/bar set white zoomed in 1.webp'
        ]
      }
    ],
    pricing: [
      {
        pieces: 1,
        price: 65,
        description: 'Complete bar set'
      }
    ]
  },

  'wine-opener': {
    id: 'wine-opener',
    name: 'Wine Opener',
    category: 'Others',
    description: 'A finely crafted wine opener that blends form and function — an essential for any wine lover.',
    longDescription: 'Handcrafted with the signature Chahine attention to detail, this wine opener is balanced for comfortable use and finished to elegant standards. A refined tool and a memorable gift.',
    variants: [
      {
        id: 'wine-opener-classic',
        name: 'Classic',
        images: [
          '/images/items/wine opener.webp',
          '/images/items/wine opener 1.webp',
          '/images/items/wine opener 2.webp'
        ]
      }
    ],
    pricing: [
      {
        pieces: 1,
        price: 25,
        description: 'Single wine opener'
      }
    ]
  },

  'beer-opener': {
    id: 'beer-opener',
    name: 'Beer Opener',
    category: 'Others',
    description: 'A sturdy, elegantly finished beer opener crafted for everyday use and effortless entertaining.',
    longDescription: 'Combining durability with refined design, this beer opener reflects the Chahine standard of quality. Comfortable to hold and beautifully finished, it makes a practical yet distinguished gift.',
    variants: [
      {
        id: 'beer-opener-classic',
        name: 'Classic',
        images: [
          '/images/items/beer opener.webp',
          '/images/items/beer opener 1.webp',
          '/images/items/beer opener 2.webp'
        ]
      }
    ],
    pricing: [
      {
        pieces: 1,
        price: 15,
        description: 'Single beer opener'
      }
    ]
  },

  'letter-opener': {
    id: 'letter-opener',
    name: 'Letter Opener',
    category: 'Others',
    description: 'A graceful letter opener that brings a touch of elegance to your desk — precise and beautifully balanced.',
    longDescription: 'Hand-finished with the care that defines Chahine craftsmanship, this letter opener pairs a keen edge with a comfortable, balanced handle. A refined desk accessory and a thoughtful gift.',
    variants: [
      {
        id: 'letter-opener-classic',
        name: 'Classic',
        images: [
          '/images/items/letter opener.webp',
          '/images/items/letter opener 1.webp',
          '/images/items/letter opener 2.webp'
        ]
      }
    ],
    pricing: [
      {
        pieces: 1,
        price: 15,
        description: 'Single letter opener'
      }
    ]
  },

  'keychain': {
    id: 'keychain',
    name: 'Keychain',
    category: 'Others',
    description: 'A distinctive handcrafted keychain — a small piece of Chahine craftsmanship to carry with you.',
    longDescription: 'Compact yet finely detailed, this keychain captures the essence of Chahine craftsmanship in a everyday keepsake. A perfect small gift or personal memento.',
    variants: [
      {
        id: 'keychain-classic',
        name: 'Classic',
        images: [
          '/images/items/keychain.webp'
        ]
      }
    ],
    pricing: [
      {
        pieces: 1,
        price: 8,
        description: 'Single keychain'
      }
    ]
  },

  'cheese-wine-set': {
    id: 'cheese-wine-set',
    name: 'Cheese and Wine Set',
    category: 'Others',
    description: 'A sophisticated cheese and wine set designed for graceful entertaining and memorable gatherings.',
    longDescription: 'Our cheese and wine set brings together the tools for a refined tasting experience, each piece hand-finished to the exacting Chahine standard. An elegant centerpiece for hosting and a distinguished gift for connoisseurs.',
    variants: [
      {
        id: 'cheese-wine-classic',
        name: 'Classic',
        images: [
          '/images/items/cheese and wine set.webp'
        ]
      }
    ],
    pricing: [
      {
        pieces: 1,
        price: 65,
        description: 'Complete cheese and wine set'
      }
    ]
  }
};

// ─── FEATURED PRODUCTS ──────────────────────────────────────────────────────

export const featuredProducts = [
  {
    id: 'featured-1',
    name: '40 Pieces Dining Set',
    image: '/images/items/40 pieces-black.webp',
    category: 'Featured',
    description: 'A comprehensive 40-piece handcrafted dining set representing generations of artisanal mastery.',
    productId: 'dining-40pieces'
  },
  {
    id: 'featured-2',
    name: 'Ceremonial Dagger Collection',
    image: '/images/items/Dagger1.webp',
    category: 'Featured',
    description: 'Ceremonial dagger showcasing the pinnacle of our decorative craftsmanship and heritage techniques.',
    productId: 'ceremonial-dagger'
  },
  {
    id: 'featured-3',
    name: 'Salad Serving Set',
    image: '/images/items/Salad set-black.webp',
    category: 'Featured',
    description: 'Elegant handcrafted salad serving set — perfect for every occasion.',
    productId: 'salad-set'
  }
];

// ─── COLLECTIONS ────────────────────────────────────────────────────────────

export const collections = {
  diningsets: [
    {
      id: 'dining-card-1',
      name: '3 Pieces Dining Set',
      image: '/images/items/DiningSetW1.jpg',
      category: 'Dining Sets',
      productId: 'dining-3pieces'
    },
    {
      id: 'dining-card-2',
      name: '18 Pieces Dining Set',
      image: '/images/items/18 pieces-black.webp',
      category: 'Dining Sets',
      productId: 'dining-18pieces'
    },
    {
      id: 'dining-card-3',
      name: '22 Pieces Dining Set',
      image: '/images/items/22 pieces1-white.webp',
      category: 'Dining Sets',
      productId: 'dining-22pieces'
    },
    {
      id: 'dining-card-4',
      name: '40 Pieces Dining Set',
      image: '/images/items/40 pieces-black.webp',
      category: 'Dining Sets',
      productId: 'dining-40pieces'
    },
    {
      id: 'dining-card-5',
      name: '80 Pieces Dining Set',
      image: '/images/items/80 pieces1-white.webp',
      category: 'Dining Sets',
      productId: 'dining-80pieces'
    }
  ],
  servingsets: [
    {
      id: 'serving-card-1',
      name: 'Salad Serving Set',
      image: '/images/items/Salad set-black.webp',
      category: 'Serving Sets',
      productId: 'salad-set'
    },
    {
      id: 'serving-card-2',
      name: 'Cake Serving Set',
      image: '/images/items/Cake set1-white.webp',
      category: 'Serving Sets',
      productId: 'cake-set'
    },
    {
      id: 'serving-card-5',
      name: 'Rosto Set',
      image: '/images/items/Rosto1-white.webp',
      category: 'Serving Sets',
      productId: 'rosto-set'
    },
    {
      id: 'serving-card-3',
      name: '4 Pieces Serving Set',
      image: '/images/items/4 pieces-black.webp',
      category: 'Serving Sets',
      productId: 'serving-4pieces'
    },
    {
      id: 'serving-card-4',
      name: '7 Pieces Serving Set',
      image: '/images/items/7 pieces-white.webp',
      category: 'Serving Sets',
      productId: 'serving-7pieces'
    }
  ],
  ornamentals: [
    {
      id: 'ornamental-card-1',
      name: 'Ceremonial Dagger Collection',
      image: '/images/items/Dagger1.webp',
      category: 'Ornamentals',
      productId: 'ceremonial-dagger'
    }
  ],
  olivewood: [
    {
      id: 'olive-card-2',
      name: 'Olive Wood Salad Set',
      image: '/images/items/Salad set-olivewood.webp',
      category: 'Olive Wood',
      productId: 'olivewood-salad'
    },
    {
      id: 'olive-card-3',
      name: 'Olive Wood Cake Set',
      image: '/images/items/Salad set- olive wood.webp',
      category: 'Olive Wood',
      productId: 'olivewood-cake'
    },
    {
      id: 'olive-card-4',
      name: 'Olive Wood Office Set',
      image: '/images/items/Office set olive wood.webp',
      category: 'Olive Wood',
      productId: 'office-set-olivewood'
    },
    {
      id: 'olive-card-1',
      name: '18 Pieces Olive Wood Set',
      image: '/images/items/18 pieces1-olivewood.webp',
      category: 'Olive Wood',
      productId: 'olivewood-18pieces'
    }
  ],
  others: [
    {
      id: 'other-card-6',
      name: 'Keychain',
      image: '/images/items/keychain.webp',
      category: 'Others',
      productId: 'keychain'
    },
    {
      id: 'other-card-4',
      name: 'Beer Opener',
      image: '/images/items/beer opener.webp',
      category: 'Others',
      productId: 'beer-opener'
    },
    {
      id: 'other-card-5',
      name: 'Letter Opener',
      image: '/images/items/letter opener.webp',
      category: 'Others',
      productId: 'letter-opener'
    },
    {
      id: 'other-card-3',
      name: 'Wine Opener',
      image: '/images/items/wine opener.webp',
      category: 'Others',
      productId: 'wine-opener'
    },
    {
      id: 'other-card-2',
      name: 'Bar Set',
      image: '/images/items/Bar set black.webp',
      category: 'Others',
      productId: 'bar-set'
    },
    {
      id: 'other-card-7',
      name: 'Cheese and Wine Set',
      image: '/images/items/cheese and wine set.webp',
      category: 'Others',
      productId: 'cheese-wine-set'
    },
    {
      id: 'other-card-1',
      name: 'Office Set',
      image: '/images/items/Office set-black.webp',
      category: 'Others',
      productId: 'office-set'
    }
  ]
};

export const clients = [
  'Luxury Hotels International',
  'Fine Dining Establishments',
  'Private Collectors',
  'Culinary Institutes',
  'Heritage Restaurants',
  'Boutique Hotels'
];
